import Vec2 from 'vec2';

import { calculateNormalVector } from './calculateNormalVector';

import { DrawingShape } from '~/core/models';
import {
  ensureMutable,
  forceAssignProperty,
} from '~/core/utils/objectMutability.utils';

// adjust the directional and normal vectors inside the removedElementsHistory list
export const updateRemovedElementsHistory = (
  removedElementsHistory: DrawingShape['removedElementsHistory']
): void => {
  if (!removedElementsHistory) {
    return;
  }

  removedElementsHistory.edgesAndCorners.forEach((remEdgeCorner) => {
    const startCorner = remEdgeCorner.appliedCorners[0];
    const endCorner = remEdgeCorner.appliedCorners[1];

    if (!startCorner?.coords || !endCorner?.coords) {
      console.warn(
        'Skipping edge due to missing coordinates in appliedCorners at indices 0 or 1'
      );

      return;
    }

    const newDirVec = new Vec2(
      endCorner.coords.x - startCorner.coords.x,
      endCorner.coords.y - startCorner.coords.y
    );

    const newNormalVec = calculateNormalVector(newDirVec);
    const mutableEdge = ensureMutable(remEdgeCorner.drawingEdge);

    forceAssignProperty(mutableEdge, 'dirVec', newDirVec);
    forceAssignProperty(mutableEdge, 'normalVec', newNormalVec);

    if (mutableEdge !== remEdgeCorner.drawingEdge) {
      remEdgeCorner.drawingEdge = mutableEdge;
    }
  });
};
